var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-switch',{staticClass:"mb-2 switch-small",attrs:{"color":"success"},on:{"change":_vm.cambiarActivo},model:{value:(_vm.switch1),callback:function ($$v) {_vm.switch1=$$v},expression:"switch1"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }